import Helper from "../d3-common"
import "lodash"

const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-scale"),
    require("d3-delaunay")
)

export function drawContent() {
    const obj = this
    this.draw(this)

    this.canvas.on("mousemove", applyCirclehighlight)
    this.canvas.on("click", showToolTip)

    function getMousePos(ctx) {
        var point = d3.mouse(ctx)

        const { data } = obj.contextVoronoi.getImageData(
            point[0],
            point[1],
            1,
            1
        )
        const colorKey = `rgb(${data[0]},${data[1]},${data[2]})`

        const currentDot = obj.objArray.find(obj => {
            return obj.hiddenColor === colorKey
        })

        return currentDot
    }

    function applyCirclehighlight() {
        const currentDot = getMousePos(this)
        obj.currentDot = currentDot // remove on mouse out

        // Draw Highlight
        if (currentDot) {
            obj.drawHighlight(obj, currentDot, true)
        }
    }

    function removeCirclehighlight() {
        // Remove Highlight
        obj.drawHighlight(obj, obj.currentDot, false)
    }

    function showToolTip(d) {
        const currentDot = getMousePos(this)
        if (currentDot) {
            const tooltip = d3.select("#tooltip")

            const w = tooltip.node().offsetWidth
            const h = tooltip.node().offsetHeight

            const x = currentDot.point[0]
            const y = currentDot.point[1]
            const ctm = {}
            ctm.x = obj.transform.x
            ctm.y = obj.transform.y
            ctm.s = obj.scale

            const scalePoint = Helper.getScreenCoordsCanvas(x, y, ctm)

            // // Palette
            function convertToRGB(num) {
                return `rgb(${currentDot.colorPalette[num][0]}, ${
                    currentDot.colorPalette[num][1]
                }, ${currentDot.colorPalette[num][2]})`
            }

            for (let x = 0; x < 5; x += 1) {
                d3.select(`#p${x + 1}`).style(
                    "background-color",
                    convertToRGB(x)
                )
            }

            tooltip
                .style("opacity", 1)
                .attr("data-id2", `T${currentDot.id}`)
                .style(
                    "transform",
                    `translate(${scalePoint.x - w / 2}px, ${scalePoint.y -
                        h -
                        20}px)`
                )
                .attr("data-id", currentDot.id)
                .select("#pointer")
                .attr("data-id", currentDot.id)
                .select("#view-btn")
                .attr("data-id", currentDot.id)

            let imgEl = document.getElementById("pointer")
            imgEl.style.backgroundImage = "url('/assets/images/loading.gif')"

            Helper.loadImage(
                `${
                    currentDot.url
                }&w=200&h=200&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`
            ).then(img => {
                let photoURL = img.src
                imgEl.style.backgroundImage = "url(" + photoURL + ")"
            })
        }
    }
}

export function draw(ctx) {
    const pointArray = []
    let r = ctx.transform.k > 2 ? 2 / ctx.transform.k : 1

    ctx.context.save()
    ctx.context.clearRect(0, 0, ctx.dimensions.width, ctx.dimensions.height)
    ctx.context.translate(ctx.transform.x, ctx.transform.y)
    ctx.context.scale(ctx.transform.k, ctx.transform.k)

    ctx.dataset.forEach((d, i) => {
        const dataObj = ctx.objArray[i]

        // Calculate Coordinate
        let cx = ctx.getCoordinatesFromColor(dataObj.color, dataObj.offset)[0]
        let cy = ctx.getCoordinatesFromColor(dataObj.color, dataObj.offset)[1]

        // Create object with coordinates of point, colorCode and Unsplash ID
        dataObj.point = [cx, cy, 0, 0]
        pointArray.push(dataObj.point)

        //Drawing a circle
        ctx.context.fillStyle = dataObj.color
        ctx.context.beginPath()
        ctx.context.arc(cx, cy, r, 0, 2 * Math.PI, true)
        ctx.context.fill()
        ctx.context.closePath()
    })

    ctx.context.restore()

    // ###### Draw the delaunay grid ######
    ctx.contextVoronoi.save()
    ctx.contextVoronoi.clearRect(
        0,
        0,
        ctx.dimensions.width,
        ctx.dimensions.height
    )

    ctx.contextVoronoi.translate(ctx.transform.x, ctx.transform.y)
    ctx.contextVoronoi.scale(ctx.transform.k, ctx.transform.k)
    const delaunay = new d3.Delaunay.from(pointArray)
    const voronoi = delaunay.voronoi([
        0,
        0,
        ctx.dimensions.width,
        ctx.dimensions.height
    ])

    for (var i = 0; i < pointArray.length; i++) {
        ctx.contextVoronoi.beginPath()
        voronoi.renderCell(i, ctx.contextVoronoi)
        const color = "rgb(" + ctx.rgbColorGenerator(i) + ")"
        ctx.contextVoronoi.fillStyle = color
        ctx.contextVoronoi.fill()
        ctx.contextVoronoi.closePath()
        ctx.objArray[i].hiddenColor = color
    }

    ctx.contextVoronoi.restore()
}

export function drawHighlight(ctx, currentDot, isOver) {
    let r = ctx.transform.k > 2 ? 2 / ctx.transform.k : 1
    let rH

    if (isOver) {
        rH = r * 4
    } else {
        rH = r
    }

    ctx.contextHighlight.save()
    ctx.contextHighlight.clearRect(
        0,
        0,
        ctx.dimensions.width,
        ctx.dimensions.height
    )
    ctx.contextHighlight.translate(ctx.transform.x, ctx.transform.y)
    ctx.contextHighlight.scale(ctx.transform.k, ctx.transform.k)

    if (currentDot) {
        ctx.contextHighlight.fillStyle = currentDot.color
        ctx.contextHighlight.beginPath()
        ctx.contextHighlight.arc(
            currentDot.point[0],
            currentDot.point[1],
            rH,
            0,
            2 * Math.PI,
            true
        )
        ctx.contextHighlight.fill()
        ctx.contextHighlight.closePath()
    }
    ctx.contextHighlight.restore()
}

export function hideToolTip() {
    d3.select("#tooltip")
        .style("opacity", 0)
        .style("transform", `translate(-10000px, -10000px)`)
}

export default drawContent
